import { render, staticRenderFns } from "./ManageBulkApplicantActions.vue?vue&type=template&id=6a14af91&"
import script from "./ManageBulkApplicantActions.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ManageBulkApplicantActions.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports